module.exports = __webpack_public_path__ + "static/media/down-arrow.e26acb72.svg";